export default {
    'development.192.168.178.28': {
        rootUrl: 'http://192.168.178.28:3000',
        debug: true
    },
    'development.192.168.10.91': {
        rootUrl: 'http://192.168.10.91:3000',
        debug: true
    },
    'development.localhost': {
        rootUrl: 'http://localhost:3000',
        debug: true
    },
    'production.77.109.165.165': {
        rootUrl: 'http://77.109.165.165:8888',
    },
    'production.viewer.bint.fachwerk.io': {
        rootUrl: 'https://viewer.bint.fachwerk.io',
    },
    'production': {
        rootUrl: window.location.origin,
    }
}
